
import { Expertises } from './expertises.model';

export class ConsultantsExpertises {
  private id: number;
  private expertises: Expertises;

  constructor(ConsultantsExpertises: any) {
    this.id = ConsultantsExpertises.id;
    this.expertises = ConsultantsExpertises.expertises;
  }

  getId(): number {
    return this.id;
  }

  getExpertises(): Expertises {
    return this.expertises;
  }
}